import { render, staticRenderFns } from "./UserSearchResult.vue?vue&type=template&id=3665ea1e&scoped=true"
import script from "./UserSearchResult.vue?vue&type=script&lang=ts"
export * from "./UserSearchResult.vue?vue&type=script&lang=ts"
import style0 from "./UserSearchResult.vue?vue&type=style&index=0&id=3665ea1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3665ea1e",
  null
  
)

export default component.exports